import { render } from "./AppFooter.vue?vue&type=template&id=4bb3abd4&scoped=true&ts=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=4bb3abd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb3abd4"],['__file',"src/components/app-structure/AppFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bb3abd4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bb3abd4', __exports__)) {
    api.reload('4bb3abd4', __exports__)
  }
  
  module.hot.accept("./AppFooter.vue?vue&type=template&id=4bb3abd4&scoped=true&ts=true", () => {
    api.rerender('4bb3abd4', render)
  })

}


export default __exports__